import { type NewslettersConfig } from "@voxmedia/duet-context/context/config-context";

/**
 * Priority-ordered list of newsletters for the regwall acknowledgement screen.
 * Users will be shown the first 2 newsletters from this list that they are not
 * already subscribed to.
 */
export const regwallPriorityNewsletters = ["Verge Daily", "Verge Deals"];

const config: NewslettersConfig = {
  newslettersPageTitle: "Newsletters",
  newslettersPageDek:
    "Enter your email and select from below to get the best of The Verge straight to your inbox.",
  newslettersPageMetaDescription:
    "Enter your email and select from below to get the best of The Verge straight to your inbox.",
  newsletterSectionTitleSize: "medium",
  hideHeaderBorder: true,
  autofillEmail: true,
  newslettersPage: [
    {
      title: "Free Newsletters",
      subtitle:
        "The biggest stories, trends, and deals on the tech we care about most.",
      variant: "thumbnail",
      newsletters: ["verge-daily", "deals", "deals-alerts"],
    },
    {
      title: "Subscriber-only",
      subtitle: `Exclusive stories, must-read scoops, and deep-dive analysis from our award-winning staff. Unlock them all with a Verge subscription. To sign up, click <a href="https://www.theverge.com/subscribe">here.</a>`,
      subscriberText: `Manage newsletter subscriptions in <a href="/account/newsletters">account settings.</a>`,
      ctaUrl: "/subscribe",
      variant: "paywalledThumbnail",
      newsletters: ["notepad", "the-stepback", "optimizer", "installer"],
    },
  ],
};

export default config;
